export default __webpack_public_path__ + "static/media/header-image.ba30051d.png";